import { ProcessingOverlay } from '@components'

import { BorderRadius, Color, FormItemsGroup, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useMissingComplianceDetails } from '../../../../hooks/missingComplianceDetails/useMissingComplianceDetails'
import { useMissingCompanyDetailsForm } from '../../contexts/missingCompanyDetailsFormContext'
import { CompanyAddressSection } from './elements/CompanyAddressSection'
import { CompanyLegalStatusSection } from './elements/CompanyLegalStatusSection'
import { CompanyName } from './elements/CompanyName'
import { CompanyPaymentInfoSection } from './elements/CompanyPaymentInfoSection'
import { CompanyTaxInfoSection } from './elements/CompanyTaxInfoSection'

export const MissingCompanyDetailsModalBody = (): ReactElement => {
  const { t } = useTranslation()
  const {
    isLoading,
    isSubmitting,
    missingCompanyDetailsForm: { Form },
  } = useMissingCompanyDetailsForm()
  const { isMissingCompanyAddress, isMissingCompanyPaymentInfo, isMissingCompanyTaxInfo, isMissingLegalInfo } =
    useMissingComplianceDetails()

  const shouldShowProcessingOverlay = isLoading || isSubmitting

  return (
    <>
      {shouldShowProcessingOverlay && (
        <ProcessingOverlay borderRadius={BorderRadius.R12} color={Color.White} withAnimation />
      )}
      <Form>
        <FormItemsGroup rowSpacing={Spacing.S32}>
          <FormItemsGroup rowSpacing={Spacing.S16}>
            <Text>{t('external_invoices.missing_company_compliance_details.modal.subtitle')}</Text>
            <CompanyName />
            {isMissingLegalInfo && <CompanyLegalStatusSection />}
            {isMissingCompanyTaxInfo && <CompanyTaxInfoSection />}
          </FormItemsGroup>
          {isMissingCompanyAddress && <CompanyAddressSection />}
          {isMissingCompanyPaymentInfo && <CompanyPaymentInfoSection />}
        </FormItemsGroup>
      </Form>
    </>
  )
}
